import { Link } from "react-router-dom";
import { Shield, ArrowLeft } from "lucide-react";

const PoliticaPrivacidad = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-primary-50/20 to-secondary-50/20 py-8 px-4">
      <div className="max-w-3xl mx-auto">
        <Link to="/login" className="inline-flex items-center gap-2 text-slate-600 hover:text-primary text-sm mb-6">
          <ArrowLeft size={18} /> Volver
        </Link>
        <div className="glass-panel p-6 sm:p-10">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
              <Shield size={24} className="text-primary" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-slate-800">Política de Privacidad</h1>
              <p className="text-slate-500 text-sm">Ecosistema WCA – World Community Academy</p>
            </div>
          </div>

          <div className="prose prose-slate max-w-none text-sm sm:text-base text-slate-600 space-y-6">
            <p className="text-slate-500 text-xs">Última actualización: febrero 2026</p>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mt-6 mb-2">1. Responsable del tratamiento</h2>
              <p>El responsable del tratamiento de los datos personales en la plataforma Ecosistema WCA (en adelante, «la Plataforma») es World Community Academy / Ecosistema WCA. Para cuestiones relacionadas con la privacidad puede contactarse a: <a href="mailto:contacto@ecosistemawca.com" className="text-primary hover:underline">contacto@ecosistemawca.com</a>.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mt-6 mb-2">2. Datos que recogemos</h2>
              <p>En el uso de la Plataforma podemos recoger:</p>
              <ul className="list-disc pl-6 space-y-1 mt-2">
                <li><strong>Datos de identificación y cuenta:</strong> nombre, dirección de correo electrónico e imagen de perfil, obtenidos mediante el inicio de sesión con Google (Firebase Authentication).</li>
                <li><strong>Datos de uso:</strong> acceso a módulos, direcciones y divisiones asignadas a su cuenta, y actividad dentro de la Plataforma según los permisos de su rol.</li>
                <li><strong>Datos que usted facilita:</strong> contenido de reportes o sugerencias, y, si así lo autoriza, la vinculación de su cuenta de Google para añadir eventos al calendario de Google.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mt-6 mb-2">3. Finalidad del tratamiento</h2>
              <p>Utilizamos sus datos para: gestionar el acceso y la autenticación en la Plataforma; asignar permisos y módulos según su rol; atender reportes y sugerencias; y, en caso de que vincule Google Calendar, crear eventos en su calendario cuando usted lo solicite explícitamente desde la Plataforma.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mt-6 mb-2">4. Base legal y conservación</h2>
              <p>El tratamiento se basa en la ejecución del servicio que usted utiliza y, cuando corresponda, en su consentimiento (por ejemplo, para la vinculación con Google Calendar). Conservamos los datos mientras sea necesario para la prestación del servicio y el cumplimiento de obligaciones legales.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mt-6 mb-2">5. Destinatarios y transferencias</h2>
              <p>Los datos se procesan en los sistemas que dan soporte a la Plataforma (incluidos servicios en la nube y proveedores como Firebase y, en su caso, servicios de Google para las funcionalidades que usted autorice). No realizamos venta de datos personales.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mt-6 mb-2">6. Derechos</h2>
              <p>Usted puede ejercer los derechos de acceso, rectificación, supresión, limitación del tratamiento, oposición y portabilidad, cuando legalmente corresponda, dirigiendo una solicitud a <a href="mailto:contacto@ecosistemawca.com" className="text-primary hover:underline">contacto@ecosistemawca.com</a>. También tiene derecho a presentar una reclamación ante la autoridad de control de protección de datos competente.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mt-6 mb-2">7. Seguridad</h2>
              <p>Aplicamos medidas técnicas y organizativas adecuadas para proteger sus datos personales frente a accesos no autorizados, pérdida o alteración.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mt-6 mb-2">8. Cambios</h2>
              <p>Cualquier cambio relevante en esta política se reflejará en esta página, con indicación de la fecha de última actualización. Le recomendamos revisarla periódicamente.</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoliticaPrivacidad;
